import React from "react"

export default function OpenLink() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
      <g clipPath="url(#clip0_669_6261)">
        <path d="M13.2497 13.2319H3.91634V3.89852H8.58301V2.56519H3.91634C3.17634 2.56519 2.58301 3.16519 2.58301 3.89852V13.2319C2.58301 13.9652 3.17634 14.5652 3.91634 14.5652H13.2497C13.983 14.5652 14.583 13.9652 14.583 13.2319V8.56519H13.2497V13.2319ZM9.91634 2.56519V3.89852H12.3097L5.75634 10.4519L6.69634 11.3919L13.2497 4.83852V7.23185H14.583V2.56519H9.91634Z" fill="#101010" />
      </g>
      <defs>
        <clipPath id="clip0_669_6261">
          <rect width="16" height="16" fill="white" transform="translate(0.583008 0.565186)" />
        </clipPath>
      </defs>
    </svg>
  )
}
